import { finalCta, trustBadges } from "../lib/content";
import { ArrowRightIcon } from "./Icons";
import SmartLink from "./SmartLink";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-brand-600">
      <div className="pointer-events-none absolute inset-0 bg-grid opacity-[0.18]" />

      <div className="container-page relative py-20 sm:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            {finalCta.heading}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-brand-50">{finalCta.body}</p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <SmartLink
              href={finalCta.primaryCta.href}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-semibold text-brand-700 transition-colors hover:bg-brand-50 sm:w-auto"
            >
              {finalCta.primaryCta.label}
              <ArrowRightIcon />
            </SmartLink>
            <SmartLink
              href={finalCta.secondaryCta.href}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-white/40 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10 sm:w-auto"
            >
              {finalCta.secondaryCta.label}
            </SmartLink>
          </div>

          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {trustBadges.slice(0, 3).map((badge) => (
              <li key={badge} className="text-xs font-medium text-brand-50/90">
                {badge}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
